module ProcessList {
    export class NotificationListeners {
        [method: string]: Function
    }

    export abstract class NotificationHubServiceBase {
        protected hub: any;
        protected startPromise: PromiseLike<any>

        constructor($rootScope: ng.IRootScopeService, Hub, $timeout: ng.ITimeoutService, private hubName: string, listeners: NotificationListeners, methods: string[] = []) {
            this.hub = new Hub(hubName, {
                autoConnect: false, // disabling connections in old process list as the data format has changed 
                rootPath: "signalr",
                useSharedConnection: false,
                logging: true,
                listeners: listeners,
                methods: methods,
                queryParams: {},
                errorHandler: function (error) {
                    console.log(error);
                },
                hubDisconnected: () => {
                    console.log("signalR disconnected for hub "+hubName);
                    if (this.hub.connection.lastError) {
                        console.log("retrying signalR to "+hubName+" connection in 10 seconds");
                        $timeout(()=> {
                            this.hub.connection.start()
                                .done(() => {
                                    if (this.hub.connection.state === 0) {
                                        console.log("signalR reconnected to hub "+hubName);
                                    }
                                })
                                .fail(reason => {
                                    console.log(reason);
                                });
                        }, 1000 * 10);
                    }
                }
            });

            // this.startPromise = this.hub.connection.start().done(function () {
            //     console.log("signalR connected to hub "+hubName);
            // });
        }
    }
}